import { useContext } from 'react';
import { PreferredLanguageContext } from './preferred_language_context';

export function usePreferredLanguageContext() {
  const context = useContext(PreferredLanguageContext);

  if (typeof context === 'undefined') {
    throw new Error(
      'usePreferredLanguageContext must be used within a PreferredLanguageContextProvider'
    );
  }

  return context;
}
